/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.noauth.TrackPublicChirpService
 */
import * as References from './TrackPublicChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.noauth.TrackPublicChirpService#getById
 */
export const GET_BY_ID_QUERY_FIELD_NAME = 'com_hubspot_academy_catalog_rpc_noauth_TrackPublicChirpService_getById';
export const GET_BY_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_ID_QUERY_FIELD_NAME,
  args: ['trackId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getByIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.noauth.TrackPublicChirpService#getByLanguageAndPagePath
 */
export const GET_BY_LANGUAGE_AND_PAGE_PATH_QUERY_FIELD_NAME = 'com_hubspot_academy_catalog_rpc_noauth_TrackPublicChirpService_getByLanguageAndPagePath';
export const GET_BY_LANGUAGE_AND_PAGE_PATH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_LANGUAGE_AND_PAGE_PATH_QUERY_FIELD_NAME,
  args: ['pagePath', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getByLanguageAndPagePathRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});